module.exports = __webpack_public_path__ + "static/img/ico.3bec8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/dragon/img/ico.png
// module id = pTDj
// module chunks = 1